var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 32",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.081 36.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21",
    d: "M74.284,50.238c-1.4-3.281-6.4-2.8-8.391-2.205a4.373,4.373,0,0,0-1.99,1.345c-.538.592-5.809,6.024-5.809,6.024l-6.24,2.367a2.965,2.965,0,0,0-1.721,3.819,2.9,2.9,0,0,0,2.743,1.883,2.331,2.331,0,0,0,1.022-.215l6.885-2.636a2.866,2.866,0,0,0,1.076-.7l.484-.538c.054,3.5.538,9.467.592,9.79a.851.851,0,0,0,.968.861H74.5a.92.92,0,0,0,.914-.968C75.521,62.717,75.79,53.735,74.284,50.238Z",
    transform: "translate(-24.422 -33.187)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 6.455,
    cy: 6.455,
    r: 6.455,
    transform: "translate(37.275)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 6.455,
    cy: 6.455,
    r: 6.455,
    transform: "translate(0.913)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 22",
    d: "M29.826,51.785a2.957,2.957,0,0,0-3.98-1.291l-5.487,2.8s-3.066-2.1-4.034-2.851a19.592,19.592,0,0,0-4.2-2.528c-1.936-.645-6.993-1.076-8.391,2.205C2.232,53.668,2.5,62.651,2.555,69.052a.92.92,0,0,0,.914.968h10.6c.645,0,.861-.377.968-.861.054-.323.645-7.584.592-10.812v-1.13l2.8,1.883a3.02,3.02,0,0,0,1.667.484,2.916,2.916,0,0,0,1.345-.323l7.046-3.6A2.826,2.826,0,0,0,29.826,51.785Z",
    transform: "translate(-2.502 -33.12)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriend);
export default __webpack_public_path__ + "static/media/friend.5c54f81a.svg";
export { ForwardRef as ReactComponent };